
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCrXwF64RuO0ar-ItyVZXtqlhIHcTqeR4c",
  authDomain: "rekhacollection-ff620.firebaseapp.com",
  projectId: "rekhacollection-ff620",
  storageBucket: "rekhacollection-ff620.firebasestorage.app",
  messagingSenderId: "414416085607",
  appId: "1:414416085607:web:c3a53bbd760ac549eeaac2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// ✅ FIXED provider
const googleProvider = new GoogleAuthProvider();
googleProvider.addScope("email");
googleProvider.addScope("profile");

// Export
export { auth, googleProvider, signInWithPopup };